// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trustpilot-wrapper[data-v-253d838e]{height:-moz-fit-content;height:fit-content;margin:2rem 0;position:relative;width:-moz-fit-content;width:fit-content}.trustpilot-overlay[data-v-253d838e]{bottom:0;left:0;opacity:0;position:absolute;right:0;top:0;z-index:1}@media screen and (min-width:1024px){.trustpilot-widget[data-v-253d838e]{margin:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
